import React from "react";
import Sheet from "react-modal-sheet";

/*
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  <button onClick={openModal}>Open Bottom Sheet</button>  
*/

const BottomSheet = ({ children, isOpen, closeModal}) => {
  return (
    <Sheet
      isOpen={isOpen}
      onClose={closeModal}
      // snapPoints={[height, height, height, 0]}
      // initialSnap={1}
    >
      <Sheet.Container>
        {/* <Sheet.Header /> */}
        <Sheet.Content>{children}</Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};
{
  /* <>
      <Sheet.ModalSheet
        isOpen={isOpen}
        onClose={closeModal}
        animation="slideUp"
      >
        <Sheet>
          <Sheet.Header>
            <h2 className="modal-title">Modal Title</h2>
            <Sheet.CloseIcon onClick={closeModal} />
          </Sheet.Header>
          <Sheet.Content>{children}</Sheet.Content>
        </Sheet>
      </Sheet.ModalSheet>
    </> */
}
export default BottomSheet;
